import * as S from './style';

export function CreatePostInput() {
  return (
    <S.CreatePostInput>공유하고 싶은 생각이 있으신가요?</S.CreatePostInput>
  );
}
